import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, noop, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';

import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  readonly whitelist = [
    'api-staging2.econdos.com.br',
    'api-staging.econdos.com.br',
    'api.econdos.com.br',
    'reports.econdos.com.br',
    'api-qa.econdos.com.br',
    'api-qa-latitude.econdos.com.br',
    'api-dev-latitude.econdos.com.br',
    'api-homolog.econdos.com.br'
  ];

  private clearSession$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private authService: AuthService,
    private modalService: NzModalService
  ) {
    this.clearSession$
      .pipe(
        filter(v => v),
        switchMap(() => from(this.authService.unregisterSession())),
        tap(() => {
          this.modalService
            .warning({
              nzTitle: 'Sessão expirada',
              nzContent: 'Sua sessão expirou. Faça o login novamente!'
            })
            .afterClose.subscribe(() => {
              window.location.reload();
            });
        })
      )
      .subscribe({ next: () => noop, error: noop });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        const url = request.url || '';
        if (err.status === 401 && !url.includes('users/me') && this.whitelist.some(white => url.includes(white))) {
          // auto logout if 401 response returned from api
          this.clearSession$.next(true);
          return of(err);
        } else {
          return throwError(err);
        }
      })
    );
  }
}
